/* EVERGLEAM — interactions (vanilla, one file for all pages) */
(function () {
  if (window.__egInit) return;
  window.__egInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.eg-reveal:not(.eg-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('eg-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('eg-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initSnow() {
    document.querySelectorAll('.eg-snow[data-flakes]').forEach(function (box) {
      if (box.dataset.done || reduce) return;
      box.dataset.done = '1';
      var n = parseInt(box.dataset.flakes, 10) || 0;
      for (var i = 0; i < n; i++) {
        var f = document.createElement('i');
        var s = 2 + Math.random() * 4;
        f.style.left = Math.random() * 100 + '%';
        f.style.width = f.style.height = s + 'px';
        f.style.opacity = 0.3 + Math.random() * 0.6;
        f.style.animationDuration = 8 + Math.random() * 12 + 's';
        f.style.animationDelay = -Math.random() * 20 + 's';
        f.style.setProperty('--x', (Math.random() * 80 - 40) + 'px');
        box.appendChild(f);
      }
    });
  }

  function initRails() {
    document.querySelectorAll('[data-eg-rail]').forEach(function (rail) {
      if (rail.dataset.done) return;
      rail.dataset.done = '1';
      var hint = rail.parentNode.querySelector('.eg-rail-hint');
      if (!hint) return;
      var kids = rail.children;
      for (var i = 0; i < kids.length; i++) hint.appendChild(document.createElement('i'));
      var dots = hint.children;
      function upd() {
        var w = kids[0] ? kids[0].getBoundingClientRect().width : 1;
        var idx = Math.round(rail.scrollLeft / (w + 14));
        for (var j = 0; j < dots.length; j++) dots[j].classList.toggle('is-on', j === idx);
      }
      rail.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-eg-gallery]').forEach(function (g) {
      if (g.dataset.done) return;
      g.dataset.done = '1';
      var track = g.querySelector('.eg-gallery__track');
      var slides = g.querySelectorAll('.eg-gallery__slide');
      var dots = g.querySelectorAll('.eg-gallery__dots button');
      var thumbs = g.querySelectorAll('.eg-thumbs button');
      var count = g.querySelector('.eg-gallery__count');
      var thumbsStrip = g.querySelector('.eg-thumbs');
      var lastIdx = -1;
      function go(i) { track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }
      function centerThumb(i) {
        var t = thumbs[i];
        if (!t || !thumbsStrip) return;
        thumbsStrip.scrollTo({ left: t.offsetLeft - thumbsStrip.clientWidth / 2 + t.offsetWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
      }
      function upd() {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === idx); });
        thumbs.forEach(function (d, j) { d.classList.toggle('is-on', j === idx); });
        if (count) count.textContent = (idx + 1) + ' / ' + slides.length;
        if (idx !== lastIdx) { lastIdx = idx; centerThumb(idx); }
      }
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
      thumbs.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-eg-sticky]');
    var target = document.querySelector('[data-eg-atc]');
    if (!bar || !target || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past);
      });
    });
    io.observe(target);
  }

  function initCountdown() {
    document.querySelectorAll('[data-eg-count]').forEach(function (box) {
      var raw = box.getAttribute('data-eg-count');
      var end = new Date(raw + 'T00:00:00');
      if (isNaN(end)) return;
      var d = box.querySelector('[data-d]'), h = box.querySelector('[data-h]'), m = box.querySelector('[data-m]');
      var titleDays = document.querySelectorAll('[data-eg-days]');
      function tick() {
        var diff = Math.max(0, end - new Date());
        var days = Math.floor(diff / 864e5);
        if (d) d.textContent = days;
        if (h) h.textContent = Math.floor(diff / 36e5) % 24;
        if (m) m.textContent = Math.floor(diff / 6e4) % 60;
        titleDays.forEach(function (t) { t.textContent = days; });
      }
      tick();
      setInterval(tick, 30000);
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-eg-product]').forEach(function (wrap) {
      var json = wrap.querySelector('[data-eg-variants]');
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var selects = wrap.querySelectorAll('[data-eg-option]');
      var idInput = wrap.querySelector('input[name="id"]');
      var btns = document.querySelectorAll('[data-eg-atc-btn]');
      var prices = document.querySelectorAll('[data-eg-price]');
      var was = wrap.querySelector('[data-eg-was]');
      var fmt = wrap.getAttribute('data-money') || '${{amount}}';
      function money(c) {
        var a = (c / 100).toFixed(2);
        return fmt.replace(/\{\{\s*amount\s*\}\}/, a.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100));
      }
      function change() {
        var vals = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
        btns.forEach(function (b) {
          b.disabled = !v || !v.available;
          b.textContent = !v ? b.dataset.unavailable : (v.available ? b.dataset.add : b.dataset.soldout);
        });
        if (!v) return;
        idInput.value = v.id;
        prices.forEach(function (p) { p.textContent = money(v.price); });
        if (was) { was.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      }
      selects.forEach(function (s) { s.addEventListener('change', change); });
    });
  }

  function initAll() { initReveal(); initSnow(); initRails(); initGallery(); initSticky(); initCountdown(); initVariants(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', function () { initReveal(); initSnow(); initRails(); initGallery(); initCountdown(); });
})();
